/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 专题商品列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  commodityCondition: good.SubjectCommodityCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.CommodityDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/subject-commodities`,
    data: commodityCondition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
